import http from "@/libs/http";
const football = {
  /**审批足球- 系统管理员、青少司 */
  footballApprove: ApproveVO => {
    return http.post(http.formatUrl("football/approve"), ApproveVO);
  },
  /**批量审批足球- 系统管理员、青少司 */
  footballApproveBatch: ApproveBatchVO => {
    return http.post(http.formatUrl("football/approve/batch"), ApproveBatchVO);
  },
  /**删除足球 - 系统管理员、省、操作员*/
  footballDelete: FootBallId => {
    return http.post(http.formatUrl("football/delete"), FootBallId);
  },
  /**查看足球- 系统管理员、省、操作员*/
  footballInfo: FootBallId => {
    return http.get(http.formatUrl("football/info"), FootBallId);
  },
  /**新建足球- 系统管理员、省、操作员*/
  footballInsert: FootBallVO => {
    return http.post(http.formatUrl("football/insert"), FootBallVO);
  },
  /**查询足球分页列表 - 系统管理员、省、操作员*/
  footballPagelist: FootBallPageListVO => {
    return http.get(http.formatUrl("football/pagelist"), FootBallPageListVO);
  },
  /**撤销已提交的足球- 系统管理员、项目中心、省*/
  footballRevoke: FootBallId => {
    return http.post(http.formatUrl("football/revoke"), FootBallId);
  },
  /**提交足球- 系统管理员、项目中心、省**/
  footballSubmit: FootBallId => {
    return http.post(http.formatUrl("football/submit"), FootBallId);
  },
  /**批量提交足球- 系统管理员、项目中心、省**/
  footballSubmitBatch: BatchFootBallId => {
    return http.post(http.formatUrl("football/submit/batch"), BatchFootBallId);
  },
  /**更新足球- 系统管理员、省、操作员*/
  footballUpdate: FootBallVO => {
    return http.post(http.formatUrl("football/update"), FootBallVO);
  }
};
export default football;
